/*eslint-disable @typescript-eslint/ban-types*/
import React, { useEffect, useMemo, useState } from 'react';
import './AdvanceRuleEngineGridCard.css'
import { IAdvanceRuleEngineListItem } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import { ruleEngineStatusMapper } from '../ruleEngine/ruleEngineConstant';
import { Icon } from '../../globalUtils/globalIcons';
import { CustomSwitch, useAppDispatch } from '../../globalUtils/globalExports';
import { toggleAdvanceRuleEngineRuleStatus } from '../../rmsReduxStore/reduxExports';
import { Id, toast } from 'react-toastify';
import access from '../../auth/service/AccessControl';


interface IAdvanceRuleEngineGridCard{
    key: string,
    rule: IAdvanceRuleEngineListItem,
    fetchRules: ()=>void,
    handleDeleteRule: Function
}

const AdvanceRuleEngineGridCard: React.FC<IAdvanceRuleEngineGridCard> = (props)=>{
    const {key,rule,fetchRules,handleDeleteRule} = props;
    const [localStatus, setLocalStatus] = useState(rule?.status === 'Enabled');
    const dispatch = useAppDispatch();
    const errorToast = (msg:string):Id => toast.error(msg);
    const successToast = (msg:string):Id => toast.success(msg);

    const isRuleDeletable = useMemo(()=>{
        return access?.advanceRuleEngineAccess?.view() && rule?.runningStatus === 'Draft';
    },[rule])

    useEffect(() => {
        setLocalStatus(rule?.status === 'Enabled');
    }, [rule])

    const handleToggleChange = async (e: React.MouseEvent) => {
        e.stopPropagation();
        // Optimistically toggle the switch
        if (rule?.runningStatus === 'Draft') {
            errorToast('Rule is in Draft Mode');
            return;
        }
        setLocalStatus(prev => !prev);
        const res = await dispatch(toggleAdvanceRuleEngineRuleStatus({ ruleId: rule?.id }));
        if (res.status === 200 || res.status === 202) {
            successToast(`Rule ${res?.data?.data?.status}.`);
            fetchRules();
        } else {
            errorToast(res?.data?.message);
            setLocalStatus(rule?.status === 'Enabled');
        }
    };

  return (
    <div className='advance__rule__engine__card' key={key}>
        <div className='advance__rule__engine__card__header'>
            <div className='advance__rule__engine__card__header-left'>
                <div className='advance__rule__engine__card__status'>
                    <Icon iconClassName={ruleEngineStatusMapper[rule?.runningStatus]?.icon} />
                    {
                        rule?.error === 1 && <Icon iconClassName={'rms__icon rule_engine_error_status_icon'}/>
                    }
                </div>
                <div className='advance__rule__engine__card__name-container'>
                    <div className='advance__rule__engine__card__name'>
                        {rule?.ruleName}
                    </div>
                </div>
            </div>
            <div className='advance__rule__engine__card__action'>
                <div className='advance__rule__engine__status__toggle__switch'>
                    <CustomSwitch 
                        switchId={'advance__rule__engine__single__notification__status-switch-'+rule?.id} 
                        switchClassName={'advance__rule__engine__single__notification__status-switch'}
                        handleClick={handleToggleChange}
                        checked={localStatus} 
                        customSpacing={0}
                    />
                </div>
                {
                    isRuleDeletable && <div className='advance__rule__engine__delete__rule__btn'>
                        <Icon iconClassName={'rms__delete__icon'} onIconClick={()=>{handleDeleteRule(rule,isRuleDeletable)}}/>
                    </div>
                }
            </div>
        </div>
        <div className='advance__rule__engine__card__description'>
            {rule?.description ?? '-'}
        </div>
    </div>
  )
}

export default AdvanceRuleEngineGridCard